module.exports = __webpack_public_path__ + "images/emoji/us.7b70fd8372b2ae17897a.png";